<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],

      ismobile: false,
      activeNames: [],
      activeapp: [],
      showmodel: "1",
      userinfo: [],
      safeinfo: [],
      loading: true,
      goodslist: [],
      cashierconfig: [],
      syncgoodslist: [],
      multipleSelection: [] // 批量选择
    };
  },
  async mounted() {
    await this.$permissionManager.ensureReady();
    if (!this.$hasPermission("goods.view")) {
      this.$message.error(this.$t("global.text.missingPermission"));
      this.$router.replace({ name: "403 Forbidden" });
      return;
    }
    this.title = this.$t("menuitems.goods.text");
    this.items = [
      {
        text: this.$t("menuitems.goods.text"),
        active: true,
      },
    ];

    this.userinfo = JSON.parse(localStorage.getItem("user"));
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    this.getgoodslist();
    this.getcashierconfig();
  },
  methods: {
    getgoodslist() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "goodslist",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data && response.data.data) {
            this.goodslist = response.data.data;
          } else {
            this.goodslist = [];
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取商品列表失败:", error);
          this.$message.error(this.$t("global.errors.network") || "网络错误");
        });
    },
    deletegoods(id) {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "deletegoods",
            id: id,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.$toast.clear();
          if (response.data && response.data.status == 200) {
            this.$message({
              message: this.$t("global.success"),
              type: "success",
            });
            this.getgoodslist();
          } else {
            this.$message.error(response.data?.msg || this.$t("global.delete.500"));
          }
        })
        .catch((error) => {
          console.error("删除商品失败:", error);
          this.$message.error(this.$t("global.errors.network") || "网络错误");
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning(this.$t("goods.lists.select_goods") || "请先选择要删除的商品");
        return;
      }
      
      this.$confirm(
        this.$t("goods.lists.batch_delete_tips", { count: this.multipleSelection.length }) || 
        `确定要删除选中的 ${this.multipleSelection.length} 个商品吗？`,
        this.$t("goods.lists.batch_delete_title") || "批量删除",
        {
          confirmButtonText: this.$t("global.confirm") || "确定",
          cancelButtonText: this.$t("global.cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          const deletePromises = this.multipleSelection.map((goods) => {
            return this.$axios.post(
              this.apiuri,
              {
                action: "deletegoods",
                id: goods.id,
              },
              {
                headers: { Openid: this.userinfo.openid },
              }
            );
          });

          Promise.all(deletePromises)
            .then((responses) => {
              this.loading = false;
              const successCount = responses.filter(
                (response) => response.data && response.data.status == 200
              ).length;
              
              if (successCount === this.multipleSelection.length) {
                this.$message({
                  message: this.$t("goods.lists.batch_delete_success", { count: successCount }) || 
                    `成功删除 ${successCount} 个商品`,
                  type: "success",
                });
              } else {
                this.$message.warning(
                  this.$t("goods.lists.batch_delete_partial", { 
                    success: successCount, 
                    total: this.multipleSelection.length 
                  }) || 
                  `成功删除 ${successCount}/${this.multipleSelection.length} 个商品`
                );
              }
              
              this.multipleSelection = [];
              this.getgoodslist();
            })
            .catch((error) => {
              this.loading = false;
              console.error("批量删除失败:", error);
              this.$message.error(this.$t("global.errors.network") || "网络错误");
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    getcashierconfig() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "get_cashier_config",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data && response.data.config) {
            this.cashierconfig = response.data.config;
          } else {
            this.cashierconfig = {};
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取收银配置失败:", error);
        });
    },
    /** 与 vue-localadmin_led 同路径页面一致：get_${type}_goodslist，成功提示用接口返回 msg */
    syncgoods() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_" + that.cashierconfig.type + "_goodslist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.$message({
            message: response.data.msg,
            type: "success",
          });
          that.getgoodslist();
        })
        .catch(function (error) {
          that.loading = false;
          console.error("同步商品失败:", error);
          that.$message.error(that.$t("global.errors.network") || "网络错误");
        });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <el-card class="box-card" v-loading="loading">
          <div slot="header" class="clearfix">
            <span>
              <i class="el-icon-s-goods"></i>
              {{ $t("menuitems.goods.text") }}
            </span>
            <div style="float: right;">
              <el-button
                icon="el-icon-refresh"
                @click="getgoodslist"
                :loading="loading"
                circle
                size="small"
              ></el-button>
            </div>
          </div>

          <!-- 操作按钮（同步条件与 vue-localadmin_led/src/views/pages/goods/list.vue 一致） -->
          <div class="mb-3">
            <router-link :to="{ path: '/goods/add' }">
              <el-button type="success" icon="el-icon-plus">
                {{ $t("goods.add") }}
              </el-button>
            </router-link>
            <el-button
              v-if="
                cashierconfig.status &&
                (cashierconfig.type == 'hualala' ||
                  cashierconfig.type == 'tcsl' ||
                  cashierconfig.type == 'keruyun')
              "
              type="primary"
              icon="el-icon-refresh"
              @click="syncgoods"
              :loading="loading"
            >
              {{ $t("goods.lists.sync") || "同步商品" }}
            </el-button>
            <el-button
              v-if="multipleSelection.length > 0 && $hasPermission('admin.delete')"
              type="danger"
              icon="el-icon-delete"
              @click="batchDelete"
              :loading="loading"
            >
              {{ $t("goods.lists.batch_delete", { count: multipleSelection.length }) || `批量删除 (${multipleSelection.length})` }}
            </el-button>
          </div>

          <!-- 批量选择提示 -->
          <div class="mb-3" v-if="multipleSelection.length > 0">
            <el-alert
              :title="$t('goods.lists.selected_count', { count: multipleSelection.length }) || `已选择 ${multipleSelection.length} 个商品`"
              type="info"
              :closable="false"
              show-icon
            >
            </el-alert>
          </div>

          <!-- 表格 -->
          <el-table
            :data="goodslist"
            border
            stripe
            style="width: 100%"
            @selection-change="handleSelectionChange"
            :empty-text="$t('global.text.nodata') || '暂无数据'"
            show-overflow-tooltip
          >
            <el-table-column 
              type="selection" 
              width="55" 
              align="center"
              v-if="$hasPermission('admin.delete')"
            >
            </el-table-column>
            <el-table-column
              prop="id"
              label="ID"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              :label="$t('goods.lists.title')"
              min-width="150"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              :label="$t('goods.lists.cover')"
              align="center"
            >
              <template slot-scope="scope">
                <el-image 
                  style="width: 40px; height: 40px" 
                  :src="scope.row.coverimg" 
                  :preview-src-list="[scope.row.coverimg]"
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="description"
              :label="$t('goods.lists.description')"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              :label="$t('device.lists.action')"
              width="200"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <router-link :to="{
                  path: '/goods/add',
                  query: { id: scope.row.id },
                }">
                  <el-button type="primary" size="mini" icon="el-icon-edit" round>
                    {{ $t("device.lists.edit") }}
                  </el-button>
                </router-link>
                <el-popconfirm 
                  @confirm="deletegoods(scope.row.id)" 
                  :title="$t('goods.lists.deletetips')" 
                  v-if="$hasPermission('admin.delete')"
                >
                  <el-button 
                    slot="reference" 
                    type="danger" 
                    size="mini"
                    icon="el-icon-delete"
                    round
                  >
                    {{ $t("device.lists.delete") }}
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </div>
  </Layout>
</template>